import * as React from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { DOC_API_ROUTES } from '@/api-routes/doc';
import { axiosInstance } from '@/axios';

type ResponseType = {
  results?: string[];
};

export const QUERY_KEY_ALL = 'user-read-deeplinks';

export const useFetchReadDeeplinks = () => {
  const { isLoading, isError, data } = useQuery(
    [QUERY_KEY_ALL],
    ({ signal }) =>
      axiosInstance.get<ResponseType>(DOC_API_ROUTES.getStatus(), { signal }),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      select: (data) => {
        return data.data['results'];
      },
    }
  );
  return { isLoading, isError, deeplinks: data };
};

export const useRefetchReadDeeplinks = () => {
  const queryClient = useQueryClient();

  return React.useCallback(() => {
    return queryClient.invalidateQueries([QUERY_KEY_ALL]);
  }, [queryClient]);
};
